module.exports = __webpack_public_path__ + "assets/media/clock-prize.8613529e.svg";